export default {
  namespaced: true,
  state () {
    return {
      // 个人权证相关
      regionList: [],
      serverList: [],
      taskTypeList: []
    }
  },
  getters: {
    serverList: (state) => (params) => {
      if (state.serverList.length > 0) { return state.serverList.filter(item => item.regionId === params) }
      return []
    },
    serverName: (state) => (serverId) => {
      if (serverId == null) {
        return ''
      }
      if (state.serverList.length > 0) { return state.serverList.find(item => item.id === serverId).serverName }
      return ''
    },
    regionName: (state) => (regionId) => {
      if (regionId == null) {
        return ''
      }
      if (state.regionList.length > 0) { return state.regionList.find(item => item.id === regionId).name }
      return ''
    }
  },
  mutations: {
    setRegionList (state, obj) {
      state.regionList = obj
    },
    setServerList (state, obj) {
      state.serverList = obj
    },
    setTaskTypeList (state, obj) {
      state.taskTypeList = obj
    }
  },
  actions: {

  }
}
